import { css, setFlexDF, setProps, styled } from "theme";

interface SFilterMenuButtonsProps {
  isArabic: boolean;
}

const isArabicLang = setProps<SFilterMenuButtonsProps>(({ isArabic }) => isArabic)(css`
  flex-direction: row-reverse;
`);

export const SFilterMenuButtons = styled.div<SFilterMenuButtonsProps>`
  margin-top: 20px;
  gap: 12px;

  ${isArabicLang};
  ${setFlexDF};
`;
